import arrowLeft from "../../../public/graphics/nuoli_vasen.png";
const LeftArrow = (props) => {
  const handleLeftClick = () => {
    props.setClothes((prevObjects) => {
      const updatedObjects = [...prevObjects];
      const firstObject = updatedObjects.shift();
      updatedObjects.push(firstObject);
      return updatedObjects;
    });
  };
  return (
    <>
      <button onClick={handleLeftClick} className="arrow-selection">
        <img src={arrowLeft} className="centered-img" />
      </button>
    </>
  );
};

export default LeftArrow;
